
import Vue from 'vue';
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('section', { staticClass: 'about' }, [_c('secondary-nav'), _vm._m(0)], 1);
};
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c;
    return _c('div', { staticClass: 'su-body' }, [
      _c('div', { staticClass: 'about-us-section container' }, [
        _c('div', { staticClass: 'row' }, [
          _c('div', { staticClass: 'col-1 void-column' }),
          _c('div', { staticClass: 'col-11 col-md-10' }, [
            _c('div', { staticClass: 'row' }, [
              _c('div', { staticClass: 'col-12' }, [
                _c('h1', [
                  _vm._v(
                    ' SHOWUP is the evolution of Camus Entertainment, founded in Italy in 1990 and dedicated to the cruise entertainment industry. ',
                  ),
                ]),
              ]),
              _c('div', { staticClass: 'col-12' }, [_c('div', { staticClass: 'about-us-image' })]),
              _c('div', { staticClass: 'col-12' }, [
                _c('h3', [
                  _vm._v(
                    " Our team has created over 300 shows for international audiences, involving acrobats, dancers, singers, musicians, and performers of every kind. We have enjoyed the privilege of managing the entertainment on MSC's World Cruises, a challenge on a truly global scale requiring the programming of over 94 different shows to be performed all over the planet. ",
                  ),
                ]),
              ]),
            ]),
          ]),
        ]),
      ]),
    ]);
  },
];

export default Vue.extend({ render, staticRenderFns });
